"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatesService = void 0;
var tslib_1 = require("tslib");
var lists_1 = require("src/lists");
var location_1 = require("src/location");
var BaseLocationService_1 = require("./BaseLocationService");
var StatesService = /** @class */ (function (_super) {
    tslib_1.__extends(StatesService, _super);
    function StatesService(config) {
        var _this = _super.call(this, config) || this;
        _this.statesServiceStorageKey = 'statesInfo';
        _this.getDataForSelectOptions = function (countryCode) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, states, translations, result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getData(countryCode)];
                    case 1:
                        _a = _b.sent(), states = _a[0], translations = _a[1];
                        result = this.mapItemsToUIModel(states, translations, BaseLocationService_1.LocationItemToEnum.SelectOptionItem, location_1.StateApi.STATE_PREFIX);
                        if (result) {
                            result.sort((0, lists_1.getStringCompareFunction)('title'));
                        }
                        return [2 /*return*/, result];
                }
            });
        }); };
        _this.getTranslatedStatesObjectByCountryCode = function (countryCode) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, states, translations, result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getData(countryCode)];
                    case 1:
                        _a = _b.sent(), states = _a[0], translations = _a[1];
                        result = this.mapItemsToUIModel(states, translations, BaseLocationService_1.LocationItemToEnum.SelectOptionItem, location_1.StateApi.STATE_PREFIX);
                        return [2 /*return*/, result.reduce(function (statesObject, state) {
                                statesObject[state.value] = state.title;
                                return statesObject;
                            }, {})];
                }
            });
        }); };
        _this.getDataForFilterAutoComplete = function (countryCode) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, states, translations, result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getData(countryCode)];
                    case 1:
                        _a = _b.sent(), states = _a[0], translations = _a[1];
                        result = this.mapItemsToUIModel(states, translations, BaseLocationService_1.LocationItemToEnum.FilterAutoCompleteItem, location_1.StateApi.STATE_PREFIX);
                        if (result) {
                            result.sort((0, lists_1.getStringCompareFunction)('value'));
                        }
                        return [2 /*return*/, result];
                }
            });
        }); };
        _this.getData = function (culture) {
            var apiCountryCode = _this.parseCountryCode(culture);
            var apiLanguageCode = _this.languageCode;
            var statesPromise = _this.stateApi
                .loadStatesInfo(apiCountryCode)
                .then(_this.mapStatesApiDataToLocationInfoModel);
            var translationPromise = _this.stateTranslateApi
                .loadTranslatedStates(apiCountryCode, apiLanguageCode)
                .then(_this.mapToLocationTranslation)
                .then(_this.filterOutInvalidTranslation);
            return Promise.all([statesPromise, translationPromise]);
        };
        _this.mapToLocationTranslation = function (data) {
            var translations = data.value;
            return translations.map(function (item) {
                return { code: item.id, translation: item.name };
            });
        };
        _this.mapStatesApiDataToLocationInfoModel = function (data) {
            var states = data.value;
            return states.map(function (state) {
                return {
                    code: state.id,
                    name: state.name,
                };
            });
        };
        _this.stateApi = new location_1.StateApi({
            storage: sessionStorage,
            storageKey: _this.createDefaultStorageKey(_this.statesServiceStorageKey),
            url: config.apiUrl,
            locationApiKey: config.locationApiKey,
        });
        _this.stateTranslateApi = new location_1.StateApi({
            storage: sessionStorage,
            storageKey: _this.createLocaleStorageKey(_this.statesServiceStorageKey),
            url: config.apiUrl,
            locationApiKey: config.locationApiKey,
        });
        return _this;
    }
    Object.defineProperty(StatesService.prototype, "serviceName", {
        get: function () {
            return 'StatesService';
        },
        enumerable: false,
        configurable: true
    });
    return StatesService;
}(BaseLocationService_1.BaseLocationService));
exports.StatesService = StatesService;
